import React, { FC } from 'react';
import { styled } from '@harver/shared-ui';

import { Header } from './Header';
import { HelpButton } from './HelpButton';
import { headerHeightDesktopFactor, headerHeightMobile } from './consts';

const PageContainer = styled.div`
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    @media (min-width: 768px) {
        padding: 0 ${({ theme }) => theme.sizes.large};
    }
`;

const ContentContainer = styled.div`
    max-width: ${({ theme }) => theme.getSpacing(320)};
    width: 100%;
    margin: 0 auto 3.2rem;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    padding-top: ${headerHeightMobile};

    @media (min-width: 768px) {
        padding-top: ${({ theme }) => theme.getSpacing(headerHeightDesktopFactor + 16)};
    }
`;

function openHelpPage() {
    const supportLink =
        process.env.REACT_APP_IS_US_INSTANCE === 'true'
            ? 'https://harver-us.zendesk.com/hc/en-us'
            : 'https://support.harver.com/hc/en-us';

    const windowFeatures = 'noopener,noreferrer';
    window.open(supportLink, '_blank', windowFeatures);
}

export const Layout: FC = ({ children }) => {
    return (
        <PageContainer>
            <Header helpButton={<HelpButton onClick={openHelpPage} />} />
            <ContentContainer>{children}</ContentContainer>
        </PageContainer>
    );
};
